import { Card, Stack } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton, useAppConfig } from "../../../shared";
import { useBusinessDetailsConfig } from "../hooks";
import { TenantInfoText } from "../components";

export const BusinessDetailsConfig = () => {
  const { state, formValidator, onChange, onSubmit } =
    useBusinessDetailsConfig();
  const { taxIdTerm } = useAppConfig();
  const { formData } = state;
  const taxIdError = formValidator.current.message(
    taxIdTerm,
    formData.tax_id,
    "required",
  );

  if (state.isLoading) return <Loader />;

  return (
    <Card
      component="form"
      onSubmit={onSubmit}
      sx={{
        p: { xs: 2, sm: 1.5, md: "24px" },
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      <TenantInfoText infoKey="businessDetails" alert />
      <Stack gap={1.5}>
        <InputControl
          name="business_name"
          label="Business Name"
          value={formData.business_name}
          onChange={onChange}
        />
        <InputControl
          name="address"
          label="Address"
          placeholder="123 Main Street, City, State, ZIP"
          value={formData.address}
          onChange={onChange}
        />
        <InputControl
          name="tax_id"
          label={taxIdTerm}
          value={formData.tax_id}
          onChange={onChange}
          required
          error={Boolean(taxIdError)}
          helperText={taxIdError}
        />
        <InputControl
          name="brand_name"
          label="Branch"
          value={formData.brand_name}
          onChange={onChange}
        />
      </Stack>

      <LoadingButton
        type="submit"
        variant="contained"
        loading={state.isSubmitting}
        disabled={!state.hasChanges}
        sx={{ mt: 1.5, ml: "auto", minWidth: 48 }}
      >
        Save
      </LoadingButton>
    </Card>
  );
};
